import React, { Component } from "react";
import PageHelmet from "../component/common/HelmetMelomate";
import Breadcrumb from "../elements/common/Breadcrumb";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/HeaderMelomate";
import Footer from "../component/footer/FooterMelomate";


class PrivacyMelomate extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='Datenschutz' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Datenschutz'} />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <p className="description" style={{
                                                whiteSpace: 'pre-line'
                                            }}>
                                                <h3>Datenschutzerklärung</h3>

                                                <h4>1. Überblick</h4>
                                                <p>
                                                    Mit dieser Datenschutzerklärung informieren wir Sie gemäß Art. 13 und
                                                    14 der Datenschutz-Grundverordnung (DSGVO) darüber, welche
                                                    personenbezogenen Daten wir beim Besuch unserer Website verarbeiten,
                                                    zu welchen Zwecken und auf welcher Rechtsgrundlage dies geschieht, und
                                                    welche Rechte Ihnen zustehen.
                                                </p>
                                                <p>
                                                    Personenbezogene Daten sind alle Informationen, die sich auf eine
                                                    identifizierte oder identifizierbare natürliche Person beziehen
                                                    (Art. 4 Nr. 1 DSGVO), zum Beispiel Name, E-Mail-Adresse oder
                                                    IP-Adresse.
                                                </p>

                                                <h4>2. Verantwortlicher</h4>
                                                <p>
                                                    Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne
                                                    der DSGVO ist:
                                                </p>
                                                <p>
                                                    Melomate UG (haftungsbeschränkt){'\n'}
                                                    vertreten durch den Geschäftsführer:
                                                    Carl Philipp Sporon{'\n'}
                                                    Finkenstraße 33{'\n'}
                                                    48607 Ochtrup{'\n'}
                                                    Deutschland{'\n'}{'\n'}
                                                    Telefon: 02553/9193983{'\n'}
                                                    E-Mail: <a href="mailto:info@melomate.de">info@melomate.de</a>
                                                    {'\n'}{'\n'}
                                                    Registergericht: Steinfurt{'\n'}
                                                    Registernummer: HRB 12779
                                                </p>

                                                <h4>3. Allgemeine Hinweise zur Datenverarbeitung</h4>
                                                <p>
                                                    <strong>Rechtsgrundlagen:</strong> Wir verarbeiten personenbezogene
                                                    Daten nur, soweit eine Rechtsgrundlage dies erlaubt. In Betracht
                                                    kommen insbesondere:
                                                </p>
                                                <ul>
                                                    <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),</li>
                                                    <li>
                                                        Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung oder vorvertragliche
                                                        Maßnahmen),
                                                    </li>
                                                    <li>
                                                        Art. 6 Abs. 1 lit. c DSGVO (Erfüllung rechtlicher Verpflichtungen),
                                                    </li>
                                                    <li>Art. 6 Abs. 1 lit. f DSGVO (Wahrung berechtigter Interessen).</li>
                                                </ul>
                                                <p>
                                                    Welche Rechtsgrundlage im Einzelfall gilt, geben wir in den folgenden
                                                    Abschnitten jeweils an.
                                                </p>
                                                <p>
                                                    <strong>Empfänger:</strong> Wir verkaufen Ihre Daten nicht. Eine
                                                    Übermittlung an Dritte erfolgt nur, wenn dies in dieser Erklärung
                                                    beschrieben ist, Sie eingewilligt haben oder wir gesetzlich dazu
                                                    verpflichtet sind. Soweit wir Dienstleister einsetzen (z. B. Hosting
                                                    oder E-Mail), geschieht dies auf Grundlage eines Vertrags zur
                                                    Auftragsverarbeitung nach Art. 28 DSGVO. Diese Dienstleister
                                                    verarbeiten Ihre Daten ausschließlich nach unserer Weisung.
                                                </p>
                                                <p>
                                                    <strong>Speicherdauer:</strong> Wir speichern personenbezogene Daten
                                                    nur so lange, wie es für den jeweiligen Zweck erforderlich ist oder
                                                    gesetzliche Aufbewahrungspflichten bestehen. Die konkreten Fristen
                                                    finden Sie in den einzelnen Abschnitten.
                                                </p>
                                                <p>
                                                    <strong>Übermittlung in Drittländer:</strong> Beim Betrieb dieser
                                                    Website übermitteln wir keine personenbezogenen Daten in Länder
                                                    außerhalb der Europäischen Union bzw. des Europäischen
                                                    Wirtschaftsraums. Zu Diensten Dritter, die Sie selbst aufrufen
                                                    (z. B. Instagram), beachten Sie bitte Abschnitt 9.
                                                </p>
                                                <p>
                                                    <strong>Pflicht zur Bereitstellung:</strong> Sie sind weder
                                                    gesetzlich noch vertraglich verpflichtet, uns personenbezogene Daten
                                                    bereitzustellen. Ohne die technisch notwendigen Verbindungsdaten
                                                    (siehe Abschnitt 6) kann die Website jedoch nicht angezeigt werden.
                                                    Ohne die Pflichtangaben im Kontaktformular können wir Ihre Anfrage
                                                    nicht bearbeiten.
                                                </p>
                                                <p>
                                                    <strong>Automatisierte Entscheidungsfindung:</strong> Eine
                                                    automatisierte Entscheidungsfindung einschließlich Profiling im Sinne
                                                    von Art. 22 DSGVO findet nicht statt.
                                                </p>

                                                <h4>4. SSL- bzw. TLS-Verschlüsselung</h4>
                                                <p>
                                                    Diese Website nutzt aus Sicherheitsgründen und zum Schutz der
                                                    Übertragung vertraulicher Inhalte, etwa Ihrer Anfragen über das
                                                    Kontaktformular, eine SSL- bzw. TLS-Verschlüsselung. Eine
                                                    verschlüsselte Verbindung erkennen Sie an „https://“ in der
                                                    Adresszeile Ihres Browsers und am Schloss-Symbol.
                                                </p>
                                                <p>
                                                    Bitte beachten Sie, dass eine unverschlüsselte Übertragung, etwa bei
                                                    der Kommunikation per E-Mail, Sicherheitslücken aufweisen kann. Für
                                                    die Übermittlung vertraulicher Informationen empfehlen wir deshalb
                                                    den Weg über das verschlüsselte Kontaktformular oder den Postweg.
                                                </p>

                                                <h4>5. Hosting</h4>
                                                <p>
                                                    Diese Website wird bei einem externen Hosting-Dienstleister mit Sitz in
                                                    der Europäischen Union betrieben. Die Server befinden sich ebenfalls
                                                    innerhalb der Europäischen Union.
                                                </p>
                                                <p>
                                                    Der Hoster verarbeitet in unserem Auftrag alle Daten, die beim Aufruf der
                                                    Website anfallen, sowie die über das Kontaktformular übermittelten Daten.
                                                    Wir haben mit dem Hoster einen Vertrag zur Auftragsverarbeitung nach
                                                    Art. 28 DSGVO geschlossen. Auf Anfrage teilen wir Ihnen den Namen des
                                                    Dienstleisters gerne mit.
                                                </p>
                                                <p>
                                                    Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes
                                                    Interesse liegt in einer zuverlässigen, sicheren und effizienten
                                                    Bereitstellung unserer Website.
                                                </p>

                                                <h4>6. Server-Logfiles</h4>
                                                <p>
                                                    Bei jedem Aufruf unserer Website erfasst der Hoster automatisch
                                                    Informationen, die Ihr Browser übermittelt, und speichert sie in
                                                    sogenannten Server-Logfiles. Dies sind:
                                                </p>
                                                <ul>
                                                    <li>IP-Adresse des anfragenden Geräts,</li>
                                                    <li>Datum und Uhrzeit des Zugriffs,</li>
                                                    <li>aufgerufene Seite bzw. Datei,</li>
                                                    <li>HTTP-Statuscode und übertragene Datenmenge,</li>
                                                    <li>Referrer-URL (die zuvor besuchte Seite),</li>
                                                    <li>verwendeter Browser und Betriebssystem (User-Agent).</li>
                                                </ul>
                                                <p>
                                                    <strong>Zweck:</strong> Die Verarbeitung ist erforderlich, um die
                                                    Website auszuliefern, die Stabilität und Sicherheit des Systems zu
                                                    gewährleisten sowie Angriffe und technische Fehler zu erkennen und
                                                    abzuwehren. Eine Zusammenführung mit anderen Datenquellen oder eine
                                                    Auswertung zu Marketingzwecken findet nicht statt.
                                                </p>
                                                <p>
                                                    <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO. Unser
                                                    berechtigtes Interesse ergibt sich aus den genannten Zwecken.
                                                </p>
                                                <p>
                                                    <strong>Speicherdauer:</strong> Die Logfiles werden nach spätestens
                                                    30 Tagen automatisch gelöscht. Ausgenommen sind Daten, deren
                                                    weitere Aufbewahrung zur Aufklärung eines konkreten
                                                    Sicherheitsvorfalls erforderlich ist. Diese löschen wir, sobald der
                                                    Vorfall endgültig geklärt ist.
                                                </p>

                                                <h4>7. Cookies und vergleichbare Technologien</h4>
                                                <p>
                                                    Diese Website setzt keine Cookies und verwendet keine vergleichbaren
                                                    Technologien wie Local Storage, Tracking-Pixel oder Fingerprinting.
                                                    Es werden keine Informationen auf Ihrem Endgerät gespeichert oder aus
                                                    diesem ausgelesen. Eine Einwilligung nach § 25 des
                                                    Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG) ist
                                                    daher nicht erforderlich.
                                                </p>
                                                <p>
                                                    Wir setzen außerdem keine Analyse- oder Trackingdienste ein und laden
                                                    keine Inhalte (z. B. Schriftarten oder Skripte) von Servern Dritter.
                                                </p>

                                                <h4>8. Kontaktaufnahme</h4>
                                                <p>
                                                    <strong>Kontaktformular:</strong> Wenn Sie uns über das
                                                    Kontaktformular eine Anfrage senden, verarbeiten wir die von Ihnen
                                                    eingegebenen Daten: Name, E-Mail-Adresse, Betreff und Nachricht sowie
                                                    freiwillig weitere Angaben wie Ihre Telefonnummer. Pflichtfelder sind
                                                    als solche gekennzeichnet. Ohne diese Angaben können wir Ihre Anfrage
                                                    nicht bearbeiten.
                                                </p>
                                                <p>
                                                    <strong>E-Mail und Telefon:</strong> Wenn Sie uns per E-Mail oder
                                                    Telefon kontaktieren, verarbeiten wir die von Ihnen mitgeteilten
                                                    Daten (z. B. Name, Kontaktdaten, Inhalt der Anfrage) in gleicher
                                                    Weise.
                                                </p>
                                                <p>
                                                    <strong>Zweck und Rechtsgrundlage:</strong> Wir verarbeiten Ihre
                                                    Daten, um Ihre Anfrage und mögliche Anschlussfragen zu bearbeiten.
                                                    Hängt Ihre Anfrage mit einem Vertrag zusammen oder dient sie der
                                                    Durchführung vorvertraglicher Maßnahmen (z. B. einer
                                                    Angebotsanfrage), ist Rechtsgrundlage Art. 6 Abs. 1 lit. b DSGVO. In
                                                    allen übrigen Fällen ist Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO.
                                                    Unser berechtigtes Interesse liegt in der effektiven Bearbeitung der
                                                    an uns gerichteten Anfragen.
                                                </p>
                                                <p>
                                                    <strong>Speicherdauer:</strong> Wir löschen Ihre Anfrage spätestens
                                                    6 Monate nach ihrer abschließenden Bearbeitung. Kommt ein
                                                    Vertrag zustande oder ist die Anfrage aus anderen Gründen
                                                    aufbewahrungspflichtig, speichern wir die Daten bis zum Ablauf der
                                                    gesetzlichen Aufbewahrungsfristen nach Handels- und Steuerrecht
                                                    (§ 257 HGB, § 147 AO). Diese betragen bis zu zehn Jahre. Die
                                                    Rechtsgrundlage ist dann Art. 6 Abs. 1 lit. c DSGVO.
                                                </p>
                                                <p>
                                                    <strong>Spamschutz:</strong> Zum Schutz vor automatisierten
                                                    Spam-Einsendungen verwenden wir ein unsichtbares Formularfeld
                                                    („Honeypot“). Dabei werden keine zusätzlichen personenbezogenen Daten
                                                    verarbeitet und keine Dienste Dritter eingebunden.
                                                </p>

                                                <h4>9. Links zu Instagram</h4>
                                                <p>
                                                    Auf unserer Website befinden sich Links zu unserem Profil beim
                                                    sozialen Netzwerk Instagram, betrieben von Meta Platforms Ireland
                                                    Limited, Merrion Road, Dublin 4, D04 X2K5, Irland. Es handelt sich um
                                                    einfache Links, nicht um sogenannte Social-Media-Plugins. Beim Aufruf
                                                    unserer Website werden daher keine Daten an Instagram übermittelt.
                                                </p>
                                                <p>
                                                    Erst wenn Sie einen solchen Link anklicken, werden Sie auf die
                                                    Website von Instagram weitergeleitet. Dort gelten die
                                                    Datenschutzbestimmungen von Meta. Meta kann Daten auch in die USA
                                                    übermitteln und ist nach dem EU-U.S. Data Privacy Framework
                                                    zertifiziert. Weitere Informationen finden Sie in der{' '}
                                                    <a
                                                        href="https://privacycenter.instagram.com/policy"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Datenschutzrichtlinie von Instagram
                                                    </a>
                                                    .
                                                </p>
                                                <p>
                                                    <strong>Unser Instagram-Profil:</strong> Für die Verarbeitung Ihrer
                                                    Daten beim Besuch unseres Instagram-Profils sind wir gemeinsam mit
                                                    Meta verantwortlich (Art. 26 DSGVO), soweit Meta uns statistische
                                                    Auswertungen (Insights) zur Nutzung unseres Profils bereitstellt. Die
                                                    Einzelheiten regelt eine Vereinbarung mit Meta, die Sie hier abrufen
                                                    können:{' '}
                                                    <a
                                                        href="https://www.facebook.com/legal/terms/page_controller_addendum"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Vereinbarung über die gemeinsame Verantwortlichkeit
                                                    </a>
                                                    . Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes
                                                    Interesse liegt in der Kommunikation mit Interessenten und Kunden
                                                    sowie der Darstellung unseres Unternehmens. Ihre Betroffenenrechte
                                                    können Sie sowohl bei uns als auch bei Meta geltend machen.
                                                </p>
                                                <h4>10. Ihre Rechte als betroffene Person</h4>
                                                <p>
                                                    Sie haben nach Maßgabe der gesetzlichen Bestimmungen folgende Rechte:
                                                </p>
                                                <ul>
                                                    <li>
                                                        Recht auf Auskunft über Ihre bei uns gespeicherten Daten
                                                        (Art. 15 DSGVO),
                                                    </li>
                                                    <li>Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO),</li>
                                                    <li>Recht auf Löschung (Art. 17 DSGVO),</li>
                                                    <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
                                                    <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO),</li>
                                                    <li>
                                                        Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO, siehe
                                                        Abschnitt 11),
                                                    </li>
                                                    <li>
                                                        Recht, eine erteilte Einwilligung jederzeit mit Wirkung für die
                                                        Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO). Die Rechtmäßigkeit der
                                                        bis zum Widerruf erfolgten Verarbeitung bleibt unberührt.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an die in
                                                    Abschnitt 2 genannten Kontaktdaten.
                                                </p>

                                                <h4>11. Widerspruchsrecht nach Art. 21 DSGVO</h4>
                                                <p>
                                                    <strong>
                                                        Soweit wir Ihre personenbezogenen Daten auf Grundlage von Art. 6
                                                        Abs. 1 lit. f DSGVO (berechtigte Interessen) verarbeiten, haben Sie
                                                        das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
                                                        ergeben, jederzeit Widerspruch gegen diese Verarbeitung einzulegen.
                                                        Wir verarbeiten Ihre Daten dann nicht mehr, es sei denn, wir können
                                                        zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die
                                                        Ihre Interessen, Rechte und Freiheiten überwiegen, oder die
                                                        Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung
                                                        von Rechtsansprüchen.
                                                    </strong>
                                                </p>
                                                <p>
                                                    <strong>
                                                        Ihren Widerspruch können Sie formlos an die in Abschnitt 2
                                                        genannten Kontaktdaten richten.
                                                    </strong>
                                                </p>

                                                <h4>12. Beschwerderecht bei einer Aufsichtsbehörde</h4>
                                                <p>
                                                    Unbeschadet anderer Rechtsbehelfe haben Sie das Recht, sich bei einer
                                                    Datenschutz-Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht
                                                    sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die
                                                    DSGVO verstößt (Art. 77 DSGVO). Dies gilt insbesondere in dem
                                                    Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres Arbeitsplatzes
                                                    oder des Orts des mutmaßlichen Verstoßes.
                                                </p>
                                                <p>
                                                    Die für uns zuständige Aufsichtsbehörde ist:{'\n'}
                                                    Landesbeauftragte für Datenschutz und Informationsfreiheit
                                                    Nordrhein-Westfalen{'\n'}
                                                    Kavalleriestraße 2–4{'\n'}
                                                    40213 Düsseldorf{'\n'}
                                                    <a
                                                        href="https://www.ldi.nrw.de"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        www.ldi.nrw.de
                                                    </a>
                                                </p>

                                                <h4>13. Aktualität und Änderung dieser Datenschutzerklärung</h4>
                                                <p>
                                                    Wir passen diese Datenschutzerklärung an, sobald sich die Rechtslage
                                                    oder unsere Datenverarbeitung ändert, etwa bei der Einführung neuer
                                                    Dienste. Es gilt jeweils die auf dieser Seite veröffentlichte
                                                    Fassung.
                                                </p>
                                                <p>Stand: Oktober 2026</p>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                {/* End About Area  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment >
        )
    }
}
export default PrivacyMelomate
